module.exports = __webpack_public_path__ + "media/newstyle/images/icon-book-white-f0ebff9672d750bf36942c6b38c1268d.svg";